import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "../../api/axios";
import './styles/AdminForm.css'

const AddEditReview = () => {
  const [reviewerName, setReviewerName] = useState("");
  const [reviewText, setReviewText] = useState("");
  const [rating, setRating] = useState(5);
  const [isActive, setIsActive] = useState(true);
  const [sortOrder, setSortOrder] = useState(0);
  const [csrfToken, setCsrfToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  // Get CSRF token from cookie
  useEffect(() => {
    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("csrfToken="))
      ?.split("=")[1];
    if (token) setCsrfToken(token);
  }, []);

  // If edit mode, fetch review details
  useEffect(() => {
    if (isEdit) {
      setLoading(true);
      axios
        .get(`/api/admin/reviews/${id}`, { withCredentials: true })
        .then((res) => {
          const review = res.data.review;
          setReviewerName(review.reviewer_name);
          setReviewText(review.review_text);
          setRating(review.rating);
          setIsActive(Boolean(review.is_active));
          setSortOrder(review.sort_order || 0);
        })
        .catch((err) => {
          setError("Failed to load review data.");
        })
        .finally(() => setLoading(false));
    }
  }, [isEdit, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const payload = {
      reviewer_name: reviewerName,
      review_text: reviewText,
      rating,
      is_active: isActive ? 1 : 0,
      sort_order: sortOrder,
    };

    try {
      if (isEdit) {
        await axios.put(
          `/api/admin/reviews/${id}`,
          payload,
          {
            withCredentials: true,
            headers: { "x-csrf-token": csrfToken },
          }
        );
      } else {
        await axios.post(
          `/api/admin/reviews`,
          payload,
          {
            withCredentials: true,
            headers: { "x-csrf-token": csrfToken },
          }
        );
      }
      navigate("/admin/reviews");
    } catch (err) {
      setError("Failed to save review.");
    } finally {
      setLoading(false);
    }
  };

  return (
        <div className="admin-form-container">
        <div className="formButtons">
            <Link to="/admin/reviews">
            <button className="admin-form-btn cancel-btn">Cancel</button>
            </Link>
        </div>
        <div className="admin-form-wrapper">
            <h2>{isEdit ? "Edit Review" : "Add New Review"}</h2>
            {error && <div className="admin-form-error">{error}</div>}
            {loading && <div>Loading...</div>}
            <form onSubmit={handleSubmit} className="admin-form" autoComplete="off">
            <div className="admin-form-group">
                <label className="admin-form-label">Reviewer Name:</label>
                <input
                type="text"
                className="admin-form-input"
                value={reviewerName}
                onChange={(e) => setReviewerName(e.target.value)}
                required
                />
            </div>
            <div className="admin-form-group">
                <label className="admin-form-label">Review Text:</label>
                <textarea
                rows={4}
                className="admin-form-input"
                value={reviewText}
                onChange={(e) => setReviewText(e.target.value)}
                required
                />
            </div>
            <div className="admin-form-group">
                <label className="admin-form-label">Rating:</label>
                <select
                className="admin-form-input"
                value={rating}
                onChange={(e) => setRating(Number(e.target.value))}
                required
                >
                {[5, 4, 3, 2, 1].map((star) => (
                    <option key={star} value={star}>
                    {`${"⭐".repeat(star)} (${star})`}
                    </option>
                ))}
                </select>
            </div>
            <div className="admin-form-group">
                <label className="admin-form-label">Active:</label>
                <input
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                />{" "}
                Show on site
            </div>
            <div className="admin-form-group">
                <label className="admin-form-label">Sort Order (optional):</label>
                <input
                type="number"
                className="admin-form-input"
                value={sortOrder}
                min={0}
                onChange={(e) => setSortOrder(Number(e.target.value))}
                />
            </div>
            <button type="submit" className="admin-form-btn" disabled={loading}>
                {isEdit ? "Update" : "Add"} Review
            </button>
            </form>
        </div>
        </div>
  );
};

export default AddEditReview;
